import React from 'react';

export default function KatalogSection() {
  const pdfUrl = "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/katalog-heine-a4-low.pdf";
  const catalogCover = "https://assets.auxodev.dk/assets/f345d65a-1d50-4485-b2fa-cf1f9f3e4dca/billede-003-300x462_1.jpg";

  return (
    <section className="py-24 bg-black border-y border-brand-gray/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          {/* Left Column: Text & CTA */}
          <div className="lg:col-span-6 space-y-8">
            <div className="space-y-4">
              <span className="text-xs tracking-[0.25em] uppercase text-brand-oak font-semibold block">
                Inspiration & Design
              </span>
              <h2 className="text-3xl md:text-4xl font-light tracking-tight text-white uppercase font-display">
                Heine Design Katalog
              </h2>
              <div className="h-[1px] w-20 bg-brand-oak" />
            </div>
            
            <p className="text-sm text-brand-charcoal/80 leading-relaxed max-w-xl font-display font-light">
              Udforsk vores fulde kollektion af håndlavede danske designmøbler. Vores katalog præsenterer vores minimalistiske sofaborde, spiseborde, spejle og specialdesignede løsninger i rustfrit stål, italiensk skifer og massivt egetræ.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-brand-oak text-black text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300 rounded-none inline-block text-center font-display font-medium"
              >
                <i className="fa-solid fa-file-pdf mr-2" /> Åbn katalog (PDF)
              </a>
              <a
                href={pdfUrl}
                download="Heine-Design-Katalog.pdf"
                className="px-8 py-4 border border-brand-gray text-white text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black hover:border-white transition-all duration-300 rounded-none inline-block text-center font-display font-light"
              >
                <i className="fa-solid fa-download mr-2" /> Download katalog
              </a>
            </div>
          </div>

          {/* Right Column: Catalog Cover Image */}
          <div className="lg:col-span-6 flex justify-center lg:justify-end">
            <a 
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block max-w-md w-full aspect-[3/4.6] bg-brand-light border border-brand-gray overflow-hidden rounded-sm shadow-2xl transition-all duration-500 hover:border-brand-oak"
            >
              {/* Image */}
              <img
                src={catalogCover}
                alt="Heine Design Katalog Cover"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center space-y-3">
                <div className="w-12 h-12 rounded-full bg-brand-oak/90 flex items-center justify-center text-black shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <i className="fa-solid fa-book-open text-lg" />
                </div>
                <span className="text-xs tracking-[0.2em] uppercase text-white font-display font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75">
                  Læs kataloget
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
